module.exports = __webpack_public_path__ + "img/login-dsk.eede352a.jpg";